module.exports = __webpack_public_path__ + "static/media/venice-final.2e544cbe.png";